module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/mv_sp-e88e5c7010c4819f46175145c665e1bd.png";